import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FiUser, FiBell, FiUsers, FiLogOut } from 'react-icons/fi';
import ShieldCheckIcon from '../ShieldCheckIcon';
import api from '../../../api/api';
import { IGlobalState } from '../../../model/IGlobalState';
import { Avatar, displayName } from '../Header';

// left-hand card shared by every account page
const AccountNav: React.FC = () => {
    const user = useSelector((state: IGlobalState) => state.user);
    const [clientCount, setClientCount] = useState<number | null>(null);

    useEffect(() => {
        api().getClientDashboardResult().then(r => setClientCount(r.stocks.length)).catch(() => setClientCount(null));
    }, []);

    const logout = async () => {
        await api().logout();
        window.location.href = '/';
    };

    return <nav className="account-nav">
        <div className="me">
            <Avatar user={user} />
            <div className="text">
                <strong>{displayName(user)}</strong>
                {clientCount !== null && <span>Manages {clientCount} {clientCount === 1 ? 'client' : 'clients'}</span>}
            </div>
        </div>
        <NavLink to="/account" exact activeClassName="active"><FiUser /> My Profile</NavLink>
        <NavLink to="/account/security" activeClassName="active"><ShieldCheckIcon /> Account &amp; Security</NavLink>
        <NavLink to="/account/notifications" activeClassName="active"><FiBell /> Notification Preferences</NavLink>
        {/* spec: only for people who manage more than one company */}
        {clientCount !== null && clientCount > 1 && <NavLink to="/account/clients" activeClassName="active"><FiUsers /> My Clients</NavLink>}
        <hr />
        <button type="button" className="sign-out" onClick={logout}><FiLogOut /> Sign Out</button>
    </nav>;
};

export default AccountNav;
